// Legal pages: Privacy Policy & Terms of Service.
// Text content preserved verbatim from the original site; only chrome/layout updated.
import { TopNav, Footer } from '../components/Chrome';

export function PrivacyPolicyPage({ navigate }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopNav navigate={navigate} variant="minimal" />
      <div className="legal-wrap">
      {/* Content */}
      <div style={{ lineHeight: '1.8', color: 'var(--muted)' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
          Privacy Policy
        </h1>
        <p style={{ color: 'var(--muted)', marginBottom: '2rem' }}>
          Last Updated: February 20, 2025
        </p>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            1. Introduction
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            Welcome to Lithix-cell ("we," "our," or "us"). We are committed to protecting your personal information 
            and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard 
            your information when you use our EV battery economics platform at lithix-cell.com.
          </p>
          <p>
            Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, 
            please do not access the site.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            2. Information We Collect
          </h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            2.1 Personal Information
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            We collect personal information that you voluntarily provide to us when you register on the platform, 
            including:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Name</li>
            <li>Email address</li>
            <li>Location (country and city)</li>
            <li>Password (encrypted)</li>
          </ul>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            2.2 Information from Third-Party Services
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            If you choose to register or log in using a third-party account (such as Google), we may receive 
            information about you from that service, including your name, email address, and profile picture.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            2.3 Automatically Collected Information
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            When you visit our platform, we automatically collect certain information about your device, including:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Operating system</li>
            <li>Access times</li>
            <li>Pages viewed</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            3. How We Use Your Information
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We use the information we collect or receive to:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Create and manage your account</li>
            <li>Provide access to our battery cost analysis tools</li>
            <li>Send you updates about industry news and platform features</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Improve our platform and develop new features</li>
            <li>Monitor and analyze usage patterns and trends</li>
            <li>Detect and prevent fraud and abuse</li>
            <li>Send you marketing communications (with your consent)</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            4. How We Share Your Information
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We may share your information in the following situations:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li><strong>Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf (e.g., hosting, email delivery, analytics).</li>
            <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or asset sale, your information may be transferred.</li>
            <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
            <li><strong>With Your Consent:</strong> We may share your information for any other purpose with your consent.</li>
          </ul>
          <p>
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            5. Data Security
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We implement appropriate technical and organizational security measures to protect your personal information. 
            However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive 
            to use commercially acceptable means to protect your information, we cannot guarantee its absolute security.
          </p>
          <p>
            Your password is stored using industry-standard encryption. We recommend using a strong, unique password 
            and never sharing it with others.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            6. Data Retention
          </h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this 
            Privacy Policy, unless a longer retention period is required or permitted by law. When you delete your account, 
            we will delete or anonymize your personal information within 30 days.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            7. Your Privacy Rights
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            Depending on your location, you may have the following rights regarding your personal information:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li><strong>Access:</strong> Request a copy of the personal information we hold about you.</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information.</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information.</li>
            <li><strong>Portability:</strong> Request a copy of your data in a structured, machine-readable format.</li>
            <li><strong>Objection:</strong> Object to our processing of your personal information.</li>
            <li><strong>Restriction:</strong> Request restriction of processing your personal information.</li>
            <li><strong>Withdraw Consent:</strong> Withdraw consent where we rely on consent to process your information.</li>
          </ul>
          <p>
            To exercise these rights, please contact us at info@lithix-cell.com.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            8. Cookies and Tracking
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We use cookies and similar tracking technologies to track activity on our platform and hold certain information. 
            Cookies are files with small amounts of data that may include an anonymous unique identifier.
          </p>
          <p>
            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, 
            if you do not accept cookies, you may not be able to use some portions of our platform.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            9. Third-Party Links
          </h2>
          <p>
            Our platform may contain links to third-party websites and services. We are not responsible for the privacy 
            practices or content of these third parties. We encourage you to read the privacy policies of any third-party 
            sites you visit.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            10. Children's Privacy
          </h2>
          <p>
            Our platform is not intended for children under 18 years of age. We do not knowingly collect personal 
            information from children under 18. If you are a parent or guardian and believe your child has provided 
            us with personal information, please contact us.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            11. Changes to This Privacy Policy
          </h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
            Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy 
            Policy periodically for any changes.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            12. Contact Us
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul style={{ marginLeft: '2rem', listStyle: 'none' }}>
            <li>Email: info@lithix-cell.com</li>
            <li>Website: https://lithix-cell.com</li>
          </ul>
        </section>
      </div>
      </div>
      <Footer navigate={navigate} />
    </div>
  );
}

// TermsOfServicePage Component for Lithix-cell
// Add this to your App.jsx

export function TermsOfServicePage({ navigate }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopNav navigate={navigate} variant="minimal" />
      <div className="legal-wrap">
      {/* Content */}
      <div style={{ lineHeight: '1.8', color: 'var(--muted)' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
          Terms of Service
        </h1>
        <p style={{ color: 'var(--muted)', marginBottom: '2rem' }}>
          Last Updated: February 20, 2025
        </p>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            1. Agreement to Terms
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            These Terms of Service ("Terms") govern your access to and use of Lithix-cell (the "Platform"), 
            provided by Lithix-cell ("we," "us," or "our"). By accessing or using the Platform, you agree to be 
            bound by these Terms.
          </p>
          <p>
            If you do not agree to these Terms, you may not access or use the Platform.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            2. Description of Service
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            Lithix-cell provides an EV battery economics platform offering:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Real-time battery cost analysis and breakdowns</li>
            <li>Market intelligence and industry news</li>
            <li>Comparison tools for different battery chemistries</li>
            <li>Historical trend data and analytics</li>
            <li>Data export capabilities (for applicable subscription tiers)</li>
          </ul>
          <p>
            The Platform is provided on a subscription basis with different tier levels offering varying features and access.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            3. User Accounts
          </h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            3.1 Account Creation
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            To use certain features of the Platform, you must create an account. You agree to:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your information to keep it accurate</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            3.2 Account Eligibility
          </h3>
          <p>
            You must be at least 18 years old to create an account and use the Platform. By creating an account, 
            you represent and warrant that you meet this age requirement.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            4. Subscription Plans and Payment
          </h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            4.1 Subscription Tiers
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            The Platform offers multiple subscription tiers:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li><strong>Free Tier:</strong> Limited access to basic features</li>
            <li><strong>Professional Tier:</strong> Access to all battery chemistries and data download</li>
            <li><strong>Enterprise Tier:</strong> Cell-level cost breakdowns</li>
            <li><strong>Research Tier:</strong> Full access including cathode material breakdowns</li>
          </ul>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            4.2 Payment Terms
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            Paid subscriptions are billed on a recurring basis (monthly or annually). You authorize us to charge 
            your payment method for all fees associated with your subscription.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            4.3 Cancellation and Refunds
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            You may cancel your subscription at any time. Upon cancellation:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>You will retain access until the end of your current billing period</li>
            <li>No refunds will be provided for partial months</li>
            <li>Your account will automatically downgrade to the Free Tier</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            5. Acceptable Use
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            You agree not to:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Use the Platform for any illegal purpose or in violation of any laws</li>
            <li>Attempt to gain unauthorized access to any part of the Platform</li>
            <li>Interfere with or disrupt the Platform or servers</li>
            <li>Use automated systems (bots, scrapers) to access the Platform</li>
            <li>Reverse engineer, decompile, or disassemble any part of the Platform</li>
            <li>Share your account credentials with others</li>
            <li>Resell, redistribute, or commercially exploit Platform data without permission</li>
            <li>Remove or modify any copyright, trademark, or proprietary notices</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            6. Intellectual Property
          </h2>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            6.1 Our Rights
          </h3>
          <p style={{ marginBottom: '1rem' }}>
            The Platform and its entire contents, features, and functionality (including but not limited to information, 
            software, text, displays, images, data, and the design, selection, and arrangement thereof) are owned by 
            Lithix-cell and are protected by copyright, trademark, and other intellectual property laws.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0088ff' }}>
            6.2 Your Rights
          </h3>
          <p>
            Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access 
            and use the Platform for your personal or internal business purposes.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            7. Data Accuracy and Disclaimer
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            While we strive to provide accurate and up-to-date information:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>The data on the Platform is for informational purposes only</li>
            <li>We do not guarantee the accuracy, completeness, or timeliness of any information</li>
            <li>Battery costs and market conditions are subject to rapid change</li>
            <li>You should not rely solely on Platform data for business decisions</li>
            <li>We recommend verifying critical information from multiple sources</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            8. Limitation of Liability
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, LITHIX-CELL SHALL NOT BE LIABLE FOR:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Any indirect, incidental, special, consequential, or punitive damages</li>
            <li>Loss of profits, revenue, data, or business opportunities</li>
            <li>Errors or inaccuracies in Platform content</li>
            <li>Unauthorized access to or use of our servers</li>
            <li>Interruption or cessation of transmission to or from the Platform</li>
          </ul>
          <p>
            OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID TO US IN THE TWELVE (12) MONTHS PRECEDING 
            THE EVENT GIVING RISE TO LIABILITY.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            9. Indemnification
          </h2>
          <p>
            You agree to defend, indemnify, and hold harmless Lithix-cell and its officers, directors, employees, 
            and agents from any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees 
            arising from your violation of these Terms or your use of the Platform.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            10. Termination
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We may terminate or suspend your account and access to the Platform immediately, without prior notice, 
            for any reason, including:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
            <li>Breach of these Terms</li>
            <li>Non-payment of fees</li>
            <li>Fraudulent or illegal activity</li>
            <li>At our discretion for any other reason</li>
          </ul>
          <p>
            Upon termination, your right to use the Platform will immediately cease. Sections of these Terms that 
            by their nature should survive termination will survive.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            11. Changes to Terms
          </h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of any changes by posting 
            the new Terms on this page and updating the "Last Updated" date. Your continued use of the Platform 
            after such changes constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            12. Governing Law
          </h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of India, without regard 
            to its conflict of law provisions. Any disputes arising from these Terms or your use of the Platform 
            shall be subject to the exclusive jurisdiction of the courts located in Delhi, India.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            13. Severability
          </h2>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited 
            or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            14. Entire Agreement
          </h2>
          <p>
            These Terms, together with our Privacy Policy, constitute the entire agreement between you and Lithix-cell 
            regarding the use of the Platform, superseding any prior agreements.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text)' }}>
            15. Contact Us
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            If you have any questions about these Terms of Service, please contact us:
          </p>
          <ul style={{ marginLeft: '2rem', listStyle: 'none' }}>
            <li>Email: info@lithix-cell.com</li>
            <li>Website: https://lithix-cell.com</li>
          </ul>
        </section>
      </div>
      </div>
      <Footer navigate={navigate} />
    </div>
  );
}

